import { forwardRef, type ReactNode } from 'react'
import SoftButton, { type SoftButtonProps } from './SoftButton'

export type ActionButtonProps = Omit<SoftButtonProps, 'variant' | 'size' | 'icon'> & {
  icon: ReactNode
}

/**
 * Primary operate action — same chrome as Unconfigured Entities “Appliquer les filtres”
 * (`SoftButton` variant `soft` / `ds.btnSoft`). Icon is required.
 */
const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ icon, ...props }, ref) => (
    <SoftButton ref={ref} variant="soft" size="md" icon={icon} {...props} />
  ),
)

ActionButton.displayName = 'ActionButton'

export default ActionButton
